import type { FC } from 'react';

import { Button, Modal, Table } from 'react-bootstrap';
import { getShipmentStatusUrl } from './slate.util';
import type { SlateFormValue } from './slates.types';

export type SlatePublishErrorsModalProps = {
  isPublishingErrorsModalOpen: boolean;
  handleModalClose(): void;
  failedSlates: SlateFormValue[];
};

export const SlatePublishingErrorsModal: FC<SlatePublishErrorsModalProps> = ({
  isPublishingErrorsModalOpen,
  failedSlates,
  handleModalClose,
}) => {
  if (!isPublishingErrorsModalOpen) {
    return null;
  }
  return (
    <div>
      <Modal onHide={handleModalClose} show={isPublishingErrorsModalOpen}>
        <Modal.Header closeButton>
          <Modal.Title>Slate Publishing Errors</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table>
            <thead>
              <tr>
                <th>Variant</th>
                <th>Failure reason</th>
                <th>Upload status</th>
              </tr>
            </thead>
            <tbody>
              {failedSlates.map((slate, i) => {
                return (
                  // biome-ignore lint/suspicious/noArrayIndexKey: legacy code
                  <tr key={i}>
                    <td>{slate.variant} </td>
                    <td>{slate.publishResult?.result}</td>
                    <td>
                      <a href={getShipmentStatusUrl(slate.shipmentId ?? '')} rel="noopener noreferrer" target="_blank">
                        {' '}
                        status{' '}
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleModalClose} variant="primary">
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
